import { useContext } from "react";
import { ReferencesContext } from "../contexts/references-provider";

export const useReferences = () => useContext(ReferencesContext);
